export function splitSubtitlePreservingRest(subtitle: string): [string, string] {
    const quoteIndex = subtitle.indexOf('«');

    if (quoteIndex === -1) {
        return [subtitle, ''];
    }

    const firstPart = subtitle.substring(0, quoteIndex);

    const secondPart = subtitle.substring(quoteIndex);

    return [firstPart, secondPart];
}
